import { type FC, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Table } from 'shared/ui/TableNew'
import { type ContactsUnlinkedTableStore } from 'pages/contacts/pages/cleanup/ui/ContactsUnlinkedTable'
import { columns } from './columns'
import styles from './styles.module.scss'

type IContactsUnlinkedTableProps = {
  store: ContactsUnlinkedTableStore
}

export const ContactsUnlinkedTable: FC<IContactsUnlinkedTableProps> = observer(({ store }) => {
  const { list, tableStore, init, dispose } = store

  useEffect(() => {
    init()

    return () => {
      dispose()
    }
  }, [])

  return (
    <div className={styles.tableContainer}>
      <Table
        ariaLabel={'ContactsUnlinkedTable'}
        store={tableStore}
        emptyStateProps={{
          text: 'No unlinked contacts found',
        }}
        sxBox={{ padding: '0 16px' }}
        columns={columns(store)}
        rows={list}
      />
    </div>
  )
})
